import { createFileRoute, redirect } from "@tanstack/react-router";

/** The old standalone register. Everyone with a login is a settings page now. */
export const Route = createFileRoute("/_authenticated/_administration/users")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/users" });
  },
});
